var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ads',{attrs:{"classification":"community_offer"},scopedSlots:_vm._u([{key:"ad-select-parent",fn:function(ref){
var ad = ref.ad;
return [_c('div',[_c('offer-select',{attrs:{"offer":ad.typeModel,"rules":"required"},on:{"update:offer":[function($event){return _vm.$set(ad, "typeModel", $event)},function($event){ad.type='App\\Models\\CommunityOffer'}]}})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }